import { render, staticRenderFns } from "./ReferralsNewMakeForm.vue?vue&type=template&id=a363723e"
import script from "./ReferralsNewMakeForm.vue?vue&type=script&lang=js"
export * from "./ReferralsNewMakeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports